import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { HtmlEditorComponent } from '../../../../../shared/html-editor/html-editor.component';
import { UserEmailTemplatesService } from '../../../../../services/crud/user-email-templates.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EmailTemplate } from '../../../../../dto/templates/email-template';
import { HtmlTemplateVar } from '../../../../../dto/templates/html-template-var';
import { PdfGeneratorService } from '../../../../../services/pdf-generator.service';
import { FileHelper } from '../../../../../helpers/file-helper';
import {GrapesjsEditorComponent} from '../../../../../shared/grapesjs-editor/grapesjs-editor.component';

@Component({
  selector: 'app-user-email-templates-edit',
  templateUrl: './user-email-templates-edit.component.html',
  styleUrls: ['./user-email-templates-edit.component.css']
})
export class UserEmailTemplatesEditComponent implements OnInit {

  commands: HtmlTemplateVar[];

  id: number;

  @ViewChild(HtmlEditorComponent, { static: false }) editor: HtmlEditorComponent;

  constructor(
    private templatesService: UserEmailTemplatesService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private pdfGeneratorService: PdfGeneratorService
  ) { }

  templateForm: FormGroup;

  ngOnInit() {
    this.id = parseInt(this.route.snapshot.paramMap.get('id'));

    if (Number.isNaN(this.id)) {
      this.initForm(new EmailTemplate());
    } else {
      this.templatesService.get(this.id).subscribe(result => {
        this.initForm(result);
      });
    }
  }

  insert(command: string) {
    this.editor.insertHtml(command);
  }

  initForm(template: EmailTemplate) {

    this.templateForm = this.formBuilder.group({
      id: template.id,
      name: template.name,
      subject: template.subject,
      html: template.html,
      mjml: template.mjml,

      attachTermsOfService: false,
    });


    this.templatesService.getVars().subscribe(result => {
      this.commands = result.data;
      this.commandsLoaded = true;
    });
  }

  goBack() {
    this.router.navigate(['../..'], { relativeTo: this.route });
  }

  onSubmit(form: FormGroup) {
    if (Number.isNaN(this.id)) {
      this.templatesService.add(form.value).subscribe(res => this.goBack());
    } else {
      this.templatesService.update(this.id, form.value).subscribe(res => this.goBack());
    }
  }

  generatePdf() {
    this.pdfGeneratorService.generatePdf(this.templateForm.value).subscribe(result => {
      FileHelper.saveFile(result);
    });
  }

  /* grapesjs */

  sharedgjs: GrapesjsEditorComponent;
  iframeD: ElementRef;

  editorIsInit = false;
  commandsLoaded = false;
  iframeIsSet = false;



  @ViewChild('iframeD', {static: false}) set iframe(iframe: ElementRef) {
    if(iframe) { // initially setter gets called with undefined
      if(this.templateForm.value.html && !this.iframeIsSet) {
        this.iframeIsSet = true;
        this.iframeD = iframe;
        this.iframeD.nativeElement.contentWindow.frames.document.body.insertAdjacentHTML('beforebegin', this.templateForm.value.html);
      }
    }
  }

  @ViewChild('sharedgjs', {static: false}) set gEditor(gEditor: GrapesjsEditorComponent) {
    if(gEditor) { // initially setter gets called with undefined
      this.sharedgjs = gEditor;

      if(!this.editorIsInit) {
this.go();
}
      this.editorIsInit = true;
    }
  }

  saveFromEditor(data){
    this.save();
  }

  save(){
    const mjml = this.sharedgjs.editorGJS.getHtml();
    const html = this.sharedgjs.editorGJS.runCommand('mjml-get-code').html;

    this.templateForm.value.html = html;
    this.templateForm.value.mjml = mjml;

    this.onSubmit(this.templateForm);

  };

  async go(){
    let shouldStop = false;
    while(!shouldStop){

      if(this.editorIsInit && this.commandsLoaded){
        shouldStop = true;
        this.sharedgjs.go();
      }
      await this.delay(500);
    }
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }


}
